import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'
import { SectionInfo } from 'src/components/ModalForms/Frameworks/FrameworkSectionsEditor.types'

type CustomFrameworkWizardContextType = {
  name: string
  setName: (value: string) => void
  description: string
  setDescription: (value: string) => void
  sections: SectionInfo[]
  setSections: React.Dispatch<React.SetStateAction<SectionInfo[]>>
  reset: () => void
}

const CustomFrameworkWizardContext =
  createContext<CustomFrameworkWizardContextType>({
    name: '',
    setName: () => undefined,
    description: '',
    setDescription: () => undefined,
    sections: [],
    setSections: () => undefined,
    reset: () => undefined,
  })

export const CustomFrameworkWizardProvider = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [sections, setSections] = useState<SectionInfo[]>([])

  const reset = useCallback(() => {
    setName('')
    setDescription('')
    setSections([])
  }, [])

  const value = useMemo<CustomFrameworkWizardContextType>(
    () => ({
      name,
      setName,
      description,
      setDescription,
      sections,
      setSections,
      reset,
    }),
    [name, description, sections, reset],
  )

  return (
    <CustomFrameworkWizardContext.Provider value={value}>
      {children}
    </CustomFrameworkWizardContext.Provider>
  )
}

export const useCustomFrameworkWizard = (): CustomFrameworkWizardContextType =>
  useContext(CustomFrameworkWizardContext)
